<a class="text-decoration-none d-block main-card" (click)="onClick($event)">
  <div class="card border-0 p-3 card-campaign" [ngClass]="{
      'featured-campaign': campaign.isFeatured,
      'selected-campaign': campaign.selected
    }">
    <div class="d-flex flex-column gap-3">
      <div class="d-flex justify-content-between align-items-start gap-1">
        <strong class="campaign-title">{{ name }}</strong>
        <p class="m-0">
          <img [src]="openIconSrc" alt="Open Campaign Icon" />
        </p>
      </div>

      <div class="description-campaign d-flex flex-column align-items-start justify-content-center">
        <p class="m-0 text-muted text-secondary small">
          {{ description.split(' ').slice(0, 7).join(' ') }}{{ description.split(' ').length > 7 ?
          '...' : '' }}
        </p>
      </div>

      <div class="d-grid gap-2">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <span class="count-number">${{ (campaign.currentAmount / 100) | number:'1.2-2' }}</span>
          <span class="count-number">/{{ (campaign.targetAmount /100) | number: '1.0-0' }}</span>
        </div>

        <div class="progress rounded-pill" style="height: 12px;">
          <div class="progress-bar" role="progressbar" [style.width.%]="campaign.progressPct"
            [attr.aria-valuenow]="campaign.progressPct" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
    </div>
  </div>
</a>
